<script lang="ts">
  /**
   * SetRecognitionCallout — the persistent first-ever recognition card. Reads
   * the firstEverCallout store (set once per swim by initSetsDiscovered's live
   * subscription). Combines every set this swim introduced into one calm
   * sentence — no "unlock", no count, no gamification. Renders nothing when the
   * current swim introduced no new sets.
   *
   * health copy: association only, no causation claims.
   */
  import { firstEverCallout, firstEverSentence } from "../lib/setsDiscovered";
</script>

{#if $firstEverCallout && $firstEverCallout.displayNames.length > 0}
  <div class="callout" role="status">
    <span class="spark" aria-hidden="true">✦</span>
    <p>{firstEverSentence($firstEverCallout.displayNames)}</p>
  </div>
{/if}

<style>
  /* No box — a bordered, filled card nested INSIDE the sets card read as a
     third stacked widget and broke the calm. Now it is a plain recognition
     line that sits quietly in the column; the accent spark is the only colour
     cue. (feel pass, 2026-06)  */
  .callout {
    display: flex;
    align-items: baseline;
    gap: var(--space-2);
    padding: var(--space-1) 0;
  }
  /* 17px floor — Scott reads at a glance (limited eyesight). */
  .callout p {
    margin: 0;
    font-size: 17px;
    line-height: 1.35;
    color: var(--text-primary);
    font-weight: 500;
  }
  .spark {
    font-size: 16px;
    color: var(--accent-primary);
    flex-shrink: 0;
  }
</style>
